var map = {
	"./Progress-Icon-Tile.svg": 97760,
	"./Threads_1.svg": 45089,
	"./ai_stars.svg": 55306,
	"./ai_stars_color.svg": 56286,
	"./ai_stars_dark.svg": 85793,
	"./ai_stars_white.svg": 25612,
	"./folder_shared.svg": 89186,
	"./globe_icon.svg": 76203,
	"./pma_icon.svg": 52296,
	"./quarterly-objectives-icon.svg": 85750,
	"./udl-how.svg": 86098,
	"./udl-what.svg": 43998,
	"./udl-why.svg": 85798
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 91980;